import {CriterionRoute} from "@/router/Evaluation/CriterionRoute";

export const EvaluationTrainingColdFile = {
    path: '/evaluation_training_cold_files',
    name: 'evaluation_training_cold_files',
    component: () => import('@/views/Evaluation/File/EvaluationTrainingColdFilePage.vue'),
    children: [
        {
            path: '/evaluation_training_cold_files/add',
            name: 'evaluation_training_cold_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            },
            children: [
                ...CriterionRoute('evaluation_training_cold_files.add',
                    'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_COLD')
            ]
        },
        {
            path: '/evaluation_training_cold_files/edit/:id',
            name: 'evaluation_training_cold_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            },
            children: [
                ...CriterionRoute('evaluation_training_cold_files.edit',
                    'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_COLD')
            ]
        },
        {
            path: '/evaluation_training_cold_files/duplicate/:id',
            name: 'evaluation_training_cold_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            },
            children: [
                ...CriterionRoute('evaluation_training_cold_files.duplicate',
                    'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_COLD')
            ]
        },
        {
            path: '/evaluation_training_cold_files/bulk_update',
            name: 'evaluation_training_cold_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            },
            children: [
                ...CriterionRoute('evaluation_training_cold_files.bulk_update',
                    'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY',
                    'EVALUATION_TRAINING_COLD')
            ]
        },
        {
            path: '/evaluation_training_cold_files/delete/:id',
            name: 'evaluation_training_cold_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_files/view/:id',
            name: 'evaluation_training_cold_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_files/archive/:id',
            name: 'evaluation_training_cold_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                archiveAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
        {
            path: '/evaluation_training_cold_files/unarchive/:id',
            name: 'evaluation_training_cold_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_TRAINING_COLD',
            }
        },
    ]
}